import { createFileRoute } from "@tanstack/react-router";
import { QueueMonitor } from "@/components/QueueMonitor";

function RouteComponent() {
  return <QueueMonitor />;
}

export const Route = createFileRoute("/_authenticated/queue-monitor/")({
  component: RouteComponent,
  staticData: { page: ["engineering", "admin"] },
});
